import i18next from "i18next"
import type { ListItem } from "../../components/List/List"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faListCheck, faSliders } from "@fortawesome/free-solid-svg-icons"
import { SelectionEntity } from "../Selection/SelectionEntity"
import { MemoryClass } from "./MemoryClass"

export class SelectionMemory extends MemoryClass<SelectionEntity> {
  setList = (list: SelectionEntity[]) => {
    this.listData = list
  }

  protected cloneEntity(item: SelectionEntity): SelectionEntity {
    return new SelectionEntity({ ...item })
  }

  protected getItemId(item: SelectionEntity): number {
    return item.id
  }

  getListCards = (all: boolean): ListItem[] => {
    const cards: ListItem[] = []

    let count = 0

    this.listData.forEach((ss) => {
      if (all || ss.status === EEnableStatusType.Active) {
        cards.push(this.getCard(ss, count))
      }

      count++
    })

    return cards
  }

  getCard(ss: SelectionEntity, count: number): ListItem {
    const enable = ss.status === EEnableStatusType.Active

    const optionsCount = ss.options.length

    return {
      isDisable: !enable,
      id: ss.id,
      title: ss.name,
      linkImage: "",
      index: count,
      dataFilter: [
        ss.name,
        ss.description,
        ss.status.toEnableStatusTypeString(),
        ss.allowMultiple ? "multipla escolha" : "escolha unica",
        ss.isRequired ? "obrigatoria" : "opcional",
      ],
      children: (
        <div
          className={`
            rounded-2xl p-4
            transition-all duration-300
            ${enable ? "bg-gradient-to-r from-orange-50 to-white hover:shadow-lg hover:scale-[1.01]" : "bg-gray-100 opacity-70"}
          `}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex gap-3 min-w-0 flex-1">
              <div className="w-11 h-11 rounded-xl bg-orange-200 text-orange-700 flex items-center justify-center shrink-0">
                <FontAwesomeIcon icon={faSliders} />
              </div>

              <div className="min-w-0">
                <p className="text-base font-extrabold text-gray-900 truncate">{ss.name}</p>
                <p className="text-sm text-gray-700 line-clamp-2 font-medium">
                  {ss.description || i18next.t("selection:label_no_description")}
                </p>
              </div>
            </div>

            <span
              className={`px-3 py-1 text-xs font-bold rounded-full whitespace-nowrap ${
                enable ? "bg-green-100 text-green-700" : "bg-red-100 text-red-600"
              }`}
            >
              {enable ? i18next.t("selection:label_active") : i18next.t("selection:label_inactive")}
            </span>
          </div>

          <div className="border-t border-gray-200 mt-3 pt-3 flex flex-wrap gap-2">
            <span className="px-2 py-1 text-xs rounded-full bg-orange-100 text-orange-700 font-semibold flex items-center gap-1">
              <FontAwesomeIcon icon={faListCheck} className="text-gray-500" />
              {i18next.t("selection:label_options_count", { count: optionsCount })}
            </span>

            <span className="px-2 py-1 text-xs rounded-full bg-sky-100 text-sky-700 font-medium">
              {ss.allowMultiple
                ? i18next.t("selection:label_multiple_choice_badge")
                : i18next.t("selection:label_single_choice_badge")}
            </span>

            {ss.isRequired && (
              <span className="px-2 py-1 text-xs rounded-full bg-red-100 text-red-700 font-medium">
                {i18next.t("selection:label_required_badge")}
              </span>
            )}

            {ss.hasMaximumSelectionsLimit && (
              <span className="px-2 py-1 text-xs rounded-full bg-purple-100 text-purple-700 font-medium">
                {i18next.t("selection:label_maximum_selections_badge", { count: ss.maximumSelectionsLimit })}
              </span>
            )}

            {ss.freeOptionsLimit > 0 && (
              <span className="px-2 py-1 text-xs rounded-full bg-lime-100 text-lime-700 font-medium">
                {i18next.t("selection:label_free_options_limit_badge", { count: ss.freeOptionsLimit })}
              </span>
            )}
          </div>
        </div>
      ),
    }
  }
}
